import * as PropTypes from 'prop-types';
import React, { useState } from 'react';
import TextField from '../../../../components/TextField';
import { connect } from 'react-redux';
import { showMessage } from '../../../../actions/snackbar';
import { CircularProgress, InputAdornment } from '@mui/material';
import verifiedIcon from '../../../../assets/account/verified.svg';
import {
    fetchChannelContractAvailability,
    setChannelContractUserName,
    setChannelContractUserNameStatus,
} from '../../../../actions/channelContract';

const UserNameTextField = (props) => {
    const [time, setTime] = useState(null);
    const onChange = (newValue) => {
        const value = newValue?.toLowerCase() || '';

        if (/\s/.test(value)) {
            props.showMessage('Spaces are not allowed in Username');
            return;
        }

        const isValid = value === '' || /^[a-z0-9._-]+$/.test(value);
        if (!isValid) {
            props.showMessage('Only letters, numbers, underscore (_), dot (.), and hyphen (-) are allowed');
            return;
        }

        props.onChange(value);
        if (time) {
            clearInterval(time);
        }
        const data = {
            username: value,
            contractAddress: props.channelContractAddress?.account_address,
            accountAddress: props.address,
        };
        const interval = setTimeout(() => {
            props.fetchChannelContractAvailability(props.address, props.channelContractAddress?.account_address, data, (cb, error) => {
                if (cb && cb.available) {
                    props.setChannelContractUserNameStatus(false);
                } else {
                    props.setChannelContractUserNameStatus(true);
                    props.showMessage(error || 'Channel Already Exist');
                }
            },
            );
        }, 1000);
        setTime(interval);
    };

    return (
        <TextField
            id="channelUserName"
            inputProps={{
                endAdornment: (
                    <InputAdornment
                        position="end">
                        <div>
                            {props.inProgress
                                ? <CircularProgress/>
                                : !props.status
                                    ? <img alt="verified" height="23" src={verifiedIcon} width="23"/>
                                    : null}
                        </div>
                    </InputAdornment>
                ),
            }}
            name="channelUserName"
            placeholder="Enter Username"
            value={props.value}
            variant="outlined"
            onChange={onChange}/>
    );
};

UserNameTextField.propTypes = {
    address: PropTypes.string.isRequired,
    channelContractAddress: PropTypes.object.isRequired,
    fetchChannelContractAvailability: PropTypes.func.isRequired,
    inProgress: PropTypes.bool.isRequired,
    lang: PropTypes.string.isRequired,
    setChannelContractUserNameStatus: PropTypes.func.isRequired,
    showMessage: PropTypes.func.isRequired,
    status: PropTypes.bool.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

const stateToProps = (state) => {
    return {
        lang: state.language,
        value: state.channelContract.channelContractUserName,

        inProgress: state.channelContract.channelContractAvailability.inProgress,
        status: state.channelContract.channelContractUsernameStatus,
        address: state.account.connection.address,
        channelContractAddress: state.channelContract.channelContractAddress.value,
    };
};

const actionToProps = {
    onChange: setChannelContractUserName,
    fetchChannelContractAvailability,
    showMessage,
    setChannelContractUserNameStatus,
};

export default connect(stateToProps, actionToProps)(UserNameTextField);
